var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.91675 17.5002L1.13588 16.8755L0.636123 17.5002L1.13588 18.1249L1.91675 17.5002ZM15.0417 18.5002C15.594 18.5002 16.0417 18.0524 16.0417 17.5002C16.0417 16.9479 15.594 16.5002 15.0417 16.5002V18.5002ZM6.96921 9.5838L1.13588 16.8755L2.69762 18.1249L8.53095 10.8332L6.96921 9.5838ZM1.13588 18.1249L6.96921 25.4165L8.53095 24.1671L2.69762 16.8755L1.13588 18.1249ZM1.91675 18.5002H15.0417V16.5002H1.91675V18.5002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5833 11.8589V9.22168C13.5833 7.60334 13.5833 6.79417 14.0572 6.23467C14.5312 5.67518 15.3293 5.54216 16.9257 5.2761L24.0969 4.0809C27.34 3.54039 28.9615 3.27013 30.0224 4.16883C31.0833 5.06752 31.0833 6.71144 31.0833 9.99927V25.0004C31.0833 28.2882 31.0833 29.9322 30.0224 30.8308C28.9615 31.7295 27.34 31.4593 24.0969 30.9188L16.9257 29.7236C15.3293 29.4575 14.5312 29.3245 14.0572 28.765C13.5833 28.2055 13.5833 27.3963 13.5833 25.778V23.4294",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSignOut);
export default __webpack_public_path__ + "static/media/icon-sign-out.5d8faa5c111015bb1d147e31945e8803.svg";
export { ForwardRef as ReactComponent };